import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row, Container, Label, Input, InputGroup, Button, UncontrolledAlert, Form,} from "reactstrap";
import axios from "axios";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
// import Flatpickr from "react-flatpickr";

const AddAddendum = () => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken"); // Retrieve token as a plain string
  // const contractOptions = ["1", 2, 3, 4, 5, 6]

  // State management for form data, errors, and success messages
  const [newAddendum, setNewAddendum] = useState({
    title: "",
    reference: "",
    contract: "",
    created_by: "",
    file: null,
  });
  const [userName, setUserName] = useState("");
  const [contracts, setContracts] = useState([])
  const [contractOptions, setContractOptions] = useState([]);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  
  useEffect(()=>{
    async function getAllContracts(){
      const contResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/contracts`,{
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      })
      if(contResponse.ok){
        const contracts = await contResponse.json();
        setContracts(contracts)
        const contractTitles = contracts.map(cont => (cont.title))
        setContractOptions(contractTitles)
      }
      else{ console.log({contResponse})}
    }

    getAllContracts()
  }, [])

  // Get and set currently logged in user name
  // useEffect(()=>{
  //   console.log({contractOptions})
  // }, [contractOptions])

  // Fetch and set the username
    useEffect(() => {
      if (newAddendum.created_by) {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/${newAddendum.created_by}`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        })
          .then((response) => response.json())
          .then((data) => setUserName(data.username))
          .catch((error) => {
            console.error("Error fetching user:", error);
            setUserName(newAddendum.created_by)
          });
      }
    }, [newAddendum.created_by]);

  // Fetch the logged-in user's username on component mount
  useEffect(() => {
    document.title = "Add Contract || Onfon Group Legal - React";
  
    const fetchUserData = async () => {
        const userData = JSON.parse(sessionStorage.getItem("authUser"));
        setNewAddendum((prev) => ({
            ...prev,
            created_by: userData._id, // Store only the user ID
        }));
        setUserName(userData.username); // Store the user's name separately
    };
  
    fetchUserData();
  }, []);
  

  // Handle input changes for text fields
  const handleChange = async (e) => {
    const { name, value } = e.target;
  
    if (name === "contract") {
      const specContract = contracts.find((cont) => cont.title === value);
      const contr_id = specContract?.["_id"] || ""; 
  
      // Update the state to include `contr_id`
      setNewAddendum((prev) => ({ 
        ...prev, 
        [name]: value, 
        contractId: contr_id // Store contract ID in state
      }));
    } else {
      setNewAddendum((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle file upload with validation
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (
      ![
        "application/pdf",
        "application/msword",
        "application/docx",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ].includes(file.type)
    ) {
      setError("Please upload a valid file (PDF or DOC/DOCX).");
      return;
    }

    // Validate file size (5MB limit)
    if (file.size > 200 * 1024 * 1024) {
      setError("File size exceeds the maximum allowed limit of 5MB.");
      return;
    }

    setNewAddendum({ ...newAddendum, file });
  };

  // Validate form fields before submission
  const validateForm = () => {
    let isValidForm = true;
  
    // Check required fields
    const requiredFields = [
      "title",
      "reference",
      "contract",
      "created_by",
    ];
  
    for (let key of requiredFields) {
      if (!newAddendum[key]) {
        setError(`Please fill in the ${key.replace("_", " ")} field.`);
        isValidForm = false;
        break;
      }
    }
  
    // No additional date validation needed as Flatpickr ensures valid dates  
    if (isValidForm) setError(""); // Clear error if form is valid
    return isValidForm;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const apiUrl = process.env.REACT_APP_API_BASE_URL;

      // Create FormData object for file upload
      const formData = new FormData();
      Object.keys(newAddendum).forEach((key) => {

        if(key === "created_by"){
          formData[key] = JSON.parse(sessionStorage.getItem("authUser"))._id
        }
        if(key === "contract"){
          formData["contractId"] = newAddendum.contract;
          formData.delete(key)
        }

        if (key === "file" && newAddendum[key]) {
          formData.append(key, newAddendum[key]);
        } else if (newAddendum[key]) {
          formData.append(key, newAddendum[key]);
        }
      });
      console.log({formData})

      // Send request to server
      const response = await axios.post(
        `${apiUrl}/api/createAddendum`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': '*',
            "Authorization": `Bearer ${token}`, // Use token directly
          },
        }
      );

      if (response.status < 200 || response.status >= 300) {
        const errorResponse = response.data;
        setError(errorResponse)
        throw new Error("Failed to create Addendum");
      }

      setSuccess("Addendum created successfully!");
      setError(""); // Clear any existing error message
      // console.log(formData)

      setTimeout(() => {
        setSuccess("");
        setNewAddendum({
          title: "",
          reference: "",
          file: null,
          contract: "",
          created_by: newAddendum.created_by, // Retain the created_by value
        });
        navigate("/addendums"); // Redirect to sddendums page
      }, 2000);
    } catch (error) {
      console.error("Error creating addendum:", error);

      let errorMessage = "An unexpected error occurred.";
      if (error.response) {
        errorMessage = error.response.data?.message || error.response.statusText;
      } else if (error.request) {
        errorMessage = "No response from server.";
      } else {
        errorMessage = error.message;
      }

      setError(errorMessage);
    }
  };

  // Render input fields dynamically
  const renderInputField = (key) => {
    switch (key) {  
      case "file":
        return (
          <Input
            type="file"
            name="file"
            id="file"
            onChange={handleFileChange}
          />
        );
  
      case "created_by":
        return (
          <Input
            type="text"
            name="created_by"
            value={userName}
            readOnly
          />
        );

      case "contract":
        return (
          <Input type="select" name={key} value={newAddendum[key]} onChange={handleChange}>
            {(contractOptions || []).map((option) => (
              <option 
                key={option} value={option}>
                  {option}
              </option>
            ))}
          </Input>
        )

      default:
        return (
          <Input
            type="text"
            name={key}
            value={newAddendum[key]}
            onChange={handleChange}
          />
        );
    }
  };

  // Define form fields
  const formFields = [
    "title",
    "reference",
    "contract",
    "created_by", // Auto-filled by logged-in user
    "file",
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Forms" breadcrumbItem="Add New Addendum" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  {error && <UncontrolledAlert color="danger">{error}</UncontrolledAlert>}
                  {success && <UncontrolledAlert color="success">{success}</UncontrolledAlert>}
                  <Form onSubmit={handleSubmit}>
                    {formFields.map((key) => (
                      <Row className="mb-3" key={key}>
                        <Label htmlFor={key} className="col-md-2 col-form-label" id={`label-${key}`}>
                          {key
                            .replace("_", " ")
                            .replace(/\b\w/g, (l) => l.toUpperCase())}
                        </Label>
                        <div className="col-md-10">{renderInputField(key)}</div>
                      </Row>
                    ))}
                    <Button color="primary" type="submit">
                      Add Addendum
                    </Button>
                    <Button color="secondary" tag={Link} to="/addendums" className="ms-2">
                      Cancel
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddAddendum;